// assets
import { IconBellRinging } from '@tabler/icons';

// constant
const icons = {
    IconBellRinging
};

// ==============================|| EXTRA PAGES MENU ITEMS ||============================== //

const notificationPages = {
    id: 'Notifications management',
    title: 'Notifications management',
    caption: 'manage universitiy list',
    type: 'group',
    children: [
        {
            id: 'fetchNotifications',
            title: 'Notifications',
            type: 'item',
            url: '/notifications/View',
            icon:icons.IconBellRinging
        }
    ],

};

export default notificationPages;
